import { Component, ComponentRef, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatTabsModule} from '@angular/material/tabs';
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AccountLeftBannerComponent } from '../../pages/account/shared/account-left-banner/account-left-banner.component';
import { LocalStorageService } from '../../domain/model/service/local-storage.service';
import { ToasterService } from '../../shared/toaster/toaster.service';
import { AuthenticationService } from '../auth/authentication.service';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { NotificationComponent } from '../../shared/notification/notification.component';
import { ComponentPortal } from '@angular/cdk/portal';
import { NotificationType } from '../../domain/model/enums/notificationType';
import { Capacitor } from '@capacitor/core';
import { BiometricService } from '../../core/native/biometric.service';
import { LockStateService } from '../../core/native/lock-state.service';
import { PushService } from '../../core/native/push.service';
@Component({
  selector: 'app-login',
templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnDestroy{
  private overlayRef!: OverlayRef;
  hide = true;
  hideC = true;
  constructor(private readonly router: Router,
    private readonly localStorage: LocalStorageService,
    private readonly auth: AuthenticationService,private toaster: ToasterService, private overlay: Overlay,
    private readonly biometric: BiometricService,
    private readonly lockState: LockStateService,
    private readonly push: PushService) {
}
  ngOnDestroy(): void {
    this.overlayRef.detach();
  }

ngOnInit(): void {
  // Initialize an overlay and define a relative position
  // Change this to control where your toaster should appear
  this.overlayRef = this.overlay.create({
    hasBackdrop: false,
    positionStrategy: this.overlay
      .position()
      .global()
      .top("20px")
      .right("30px"),
  });
}
  form: FormGroup = new FormGroup({
    username: new FormControl('',[
      Validators.required,
      Validators.maxLength(200),
      Validators.email
    ]),
    password: new FormControl('',[
      Validators.required,
      Validators.maxLength(200),
    ]),
  });
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);
  passwordFormControl = new FormControl('', [
    Validators.required,
  ]);

  submit() {
    if (this.form.valid) {
      this.submitEM.emit(this.form.value);
    }
  }
  showNotification(message: string, title : string): void {
    // Create a Portal instance of our `NotificationComponent`
    const notificationPortal = new ComponentPortal(NotificationComponent);
    // Attach our `NotificationComponent` to the Overlay Portal
    const notificationRef: ComponentRef<NotificationComponent> =
      this.overlayRef.attach(notificationPortal);
    // Now we can access the component instance
    // and we can pass input for the `message` prop we created.
    notificationRef.instance.message = message;
    notificationRef.instance.title = title;
    notificationRef.instance.type = NotificationType.Error;
    notificationRef.instance.overlayRef = this.overlayRef;
    notificationRef.instance.getColor();
    
    // Set a timeout to detach our component from the overlay
    // after 3000 milliseconds
    setTimeout(() => {
      this.overlayRef.detach();
    }, 10000);
  }
  login() { 

    if(this.emailFormControl.invalid){
      //error message
      return;
    }
    if(this.passwordFormControl.invalid){
      //error message
      return;
    }
    this.auth.loginUser(this.emailFormControl?.value!, this.passwordFormControl.value!)
    .subscribe({
      next: (response) => {
        // A password login counts as unlocked for this session.
        this.lockState.markUnlocked();
        // Register for push notifications (native only; backend endpoint pending).
        this.push.init();
        this.handleBiometricOptIn().finally(() => this.router.navigate(['/app']));
      },
      error: (error) => {
         this.showNotification('Please verify your email and password, then try again.', 'The credentials you entered are incorrect');
      }
  });


  }

  /**
   * One-time biometric opt-in on native: the OS Face ID / fingerprint prompt
   * itself is the consent. Completing it enables biometric unlock for future
   * launches; cancelling leaves it off. No-op on web or after the first prompt.
   */
  private async handleBiometricOptIn(): Promise<void> {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    if (await this.biometric.hasBeenPrompted()) {
      return;
    }
    if (!(await this.biometric.isAvailable())) {
      await this.biometric.markPrompted();
      return;
    }
    const enabled = await this.biometric.authenticate(
      'Enable biometric unlock for faster sign-in next time',
    );
    await this.biometric.setEnabled(enabled);
    await this.biometric.markPrompted();
  }
  @Input() error: string | null | undefined;

  @Output() submitEM = new EventEmitter();
  redirectToAnotherRoute() {
    this.router.navigate(['register/createAccount']);
 
  }
  forgotPassword() {
    this.router.navigate(['forgotPassword']);
 
  }
}
